<swal id="confirm" #mySwal title="Confirm" text="Text" [showCancelButton]="true" confirmButtonText="Ok"
  cancelButtonText="Cancel"></swal>
<swal #mySwalNameInput title="Fill the form, rapidly" [showCancelButton]="true" confirmButtonText="Ok">
  <!-- This form will be displayed as the alert main content
       Targets the alert's main content zone by default -->
  <div *swalPortal>
    <div class="form-group">
      <label for="firstName" class="label">First name</label>
      <input type="text" nbInput fullWidth id="firstName" placeholder="First name" name="firstName"
        [(ngModel)]="user?.user.firstName">
    </div>
    <div class="form-group">
      <label for="lastName" class="label">Last name</label>
      <input type="text" nbInput fullWidth id="lastName" placeholder="Last name" name="lastName"
        [(ngModel)]="user?.user.lastName">
    </div>
  </div>
</swal>
<swal #mySwalAmountInput title="Fill the form, rapidly" [showCancelButton]="true" confirmButtonText="Ok">
  <!-- This form will be displayed as the alert main content
       Targets the alert's main content zone by default -->
  <div *swalPortal>
    <div class="form-group">
      <label for="amount" class="label">Amount</label>
      <input type="number" nbInput fullWidth id="amount" placeholder="0" name="amount" [(ngModel)]="selectedAmount">
    </div>
  </div>
</swal>
<swal #mySwalMessageInput title="Fill the form, rapidly" [showCancelButton]="true" confirmButtonText="Ok">
  <!-- This form will be displayed as the alert main content
       Targets the alert's main content zone by default -->
  <div *swalPortal>
    <div class="form-group">
      <label for="amount" class="label">Message</label>
      <input type="text" nbInput fullWidth id="text" placeholder="Set your message here" name="text"
        [(ngModel)]="message">
    </div>
  </div>
</swal>
<nb-card>
  <nb-card-header>
    Search a user
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <input type="text" #searchInput nbInput fullWidth (keyup)="search()" [(ngModel)]="searchValue" [nbAutocomplete]="auto">
      <nb-autocomplete #auto>

        <nb-option *ngFor="let user of users" (click)="clickItem(user);">
          {{ user.firstName + " " + user.lastName }} - {{ user.email }} - {{ user.objectID }} </nb-option>

      </nb-autocomplete>
    </div>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    Export users
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="column"><button #exportButton type="button" nbButton class="export" [disabled]="exporting" (click)="exportUsers()">Export
          users</button></div>
    </div>
    <div style="margin-top: 10px;" *ngIf="exportUsersURL && !exporting"><a [href]="exportUsersURL">Click here to
        download the Excel file</a></div>
    <div style="margin-top: 10px;" *ngIf="exporting">Please wait ... Preparing download ...</div>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    Import users
  </nb-card-header>
  <nb-card-body>
    <div class="form-group" *ngIf="!excelFileSelected">
      <label class="upload" for="file" type="button">UPLOAD EXCEL FILE</label>
      <input type="file" nbInput class="form-control" id="file" formControlName="file" (change)="onUploadExcel($event)">
    </div>
    <div class="form-group" *ngIf="excelFileSelected && amountUploaded == -1">
      Reading excel file ... Please wait ...
    </div>
    <div class="form-group" *ngIf="excelFileSelected && amountUploaded == 0">
      Upload file empty or not in a good format
    </div>
    <div class="form-group" *ngIf="excelFileSelected && amountUploaded > 0">
      Total users ready to import : {{amountUploaded}}
      <br />
      <label class="upload" for="file" type="button" (click)="importUsers()">Import users</label>
      <br />
      <label class="upload" for="file" type="button" (click)="importUsers(true)">Import users and send tokens</label>
    </div>
    <div class="form-group" *ngIf="generatedURLs && generatedURLs.length > 0">
      <div class="row"><h4>Verzonden URLs</h4></div>
      <div class="row" style="margin-top: 10px;">
        <button nbButton class="upload" (click)="exportImportedUsers()">Export URLs to Excel</button>
      </div>
      <div class="row" *ngFor="let url of generatedURLs">{{url.amount}} coupons sent to {{url.email}} with link: {{url.url}}</div>
    </div>
  </nb-card-body>
</nb-card>
<nb-card *ngIf="userFound && user">
  <nb-card-header style="position:relative">
    <div class="row">
      <div class="column">
        {{user.user.firstName}} {{user.user.lastName}}
      </div>
      <div class="column-right">
        <nb-icon (click)="showUserOptions(user.key)" class="fas fa-ellipsis-h" [nbContextMenu]="context"
          [nbContextMenuTag]="user.key" style="margin-right: 10px"></nb-icon>
        <nb-icon (click)="closeUser()" class="fas fa-times"></nb-icon>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">ID</label>
      </div>
      <div class="col-md-2">
        <label>{{user.user_id}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">Name</label>
      </div>
      <div class="col-md-2">
        <label>{{user.user.firstName}} {{user.user.lastName}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">Nickname</label>
      </div>
      <div class="col-md-2">
        <label>{{user.nickName ? user.nickName : user.user.firstName + " " + user.user.lastName}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">E-mail</label>
      </div>
      <div class="col-md-2">
        <label>{{user.user.email}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">Coupons</label>
      </div>
      <div class="col-md-2">
        <label>{{user.coupons / 100 | number: '1.0-2'}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">Manager</label>
      </div>
      <div class="col-md-2">
        <label>{{user.manager ? "Yes" : "No"}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">Token generator</label>
      </div>
      <div class="col-md-2">
        <label>{{user.tokengenerator ? "Yes" : "No"}}</label>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <label class="userLabel">Bartender</label>
      </div>
      <div class="col-md-2">
        <label>{{user.bartender ? "Yes" : "No"}}</label>
      </div>
    </div>
    <div class="form-group" *ngIf="user.qrcode !== null">
      <ngx-qrcode [elementType]="qrCodeType" [errorCorrectionLevel]="qrCodeCorrectionLevel" [value]="user.qrcode"
        cssClass="bshadow">
      </ngx-qrcode>
    </div>
    <div class="form-group" *ngIf="user.qrcode == null">
      <label>Generating QR code...</label>
    </div>
    <!--Display user categories here-->
    <div class="row">
      <div class="col-md-2">
        <h4>Categories</h4>
      </div>
      <div class="col-md-2">
        <label class="upload" type="button" (click)="addUserToCategory()">Add to category</label>
      </div>
    </div>
    <ng-container  *ngFor="let category of user.categories">
      <div class="row">
        <div class="col-md-2">
          {{cachedCategories[category]}}
        </div>
        <div class="col-md-2">
          <nb-icon class="fas fa-trash-alt" style="color: red;" (click)="removeCategoryFromUser(category)"></nb-icon>
        </div>
      </div>
    </ng-container>
    <div class="row" style="margin-top: 10px !important">
    </div>
    <div class="row">
      <!--Display transactions here-->
      <angular2-smart-table [settings]="settings" [source]="source" (rowSelect)="rowSelected($event)">
      </angular2-smart-table>
    </div>
    <ng-container *ngIf="selectedTransactionKey">
      <div class="row" style="margin-top: 10px !important; margin-bottom: 10px !important">
        <div class="col-md-2">
          <label class="userLabel">Transaction details</label>
        </div>
      </div>
      <div class="row" *ngFor="let item of order">
        <div class="col-md-2">
          <label class="userLabel">{{item.description}}</label>
        </div>
        <div class="col-md-2">
          <label>{{item.quantity}}</label>
        </div>
      </div>
    </ng-container>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    <div class="row">
      <div class="column">
        Categories
      </div>
      <div class="column-right" (click)="addCategory()">
        <label class="upload" type="button" (click)="addCategory()">Add category</label>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="categories">
      <div *ngFor="let category of categories" class="row">
        <div class=" column">
          <nb-checkbox (checkedChange)="checkedChange(category.key, $event)">{{ category.description }}</nb-checkbox>
        </div>
        <div class="column-right" (click)="deleteCategory(category.key)">
          <nb-icon class="fas fa-trash-alt" style="color: red;"></nb-icon>
        </div>
      </div>
    </div>
    <div>
      <nb-list nbInfiniteList [threshold]="500" (bottomThreshold)="loadNext()">
        <nb-list-item>
          <nb-checkbox (checkedChange)="selectAll('selectall', $event)">Select all</nb-checkbox>
        </nb-list-item>
        <nb-list-item style="position: relative;" *ngFor="let user of filteredUsers">
          <nb-checkbox [checked]="selectedUsers.indexOf(user.key) >= 0" (checkedChange)="selectUser(user.key, $event)">
            {{user.nickName ? user.nickName + " (" + user.user.firstName + " " + user.user.lastName + ")" : user.user.firstName + " " + user.user.lastName}}   -   {{user.coupons ? user.coupons / 100 : 0 | number: '1.0-2'}}
          </nb-checkbox>
        </nb-list-item>
      </nb-list>
    </div>
    <div class="row">
      <button nbButton [disabled]="selectedUsers.length === 0" (click)="sendTokensToSelectedUsers()">Send tokens to selected users</button>
    </div>
    <div class="row" style="margin-top: 10px !important">
      <button nbButton [disabled]="selectedUsers.length === 0" (click)="sendMessageToSelectedUsers()">Send message to selected users</button>
    </div>
  </nb-card-body>
</nb-card>
